<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  transportBooking: any
}

const props = defineProps<Props>()

const unseenOriginalChanges = computed(() => {
  if (!props.transportBooking.originalAttributesChangedAt) return false
  if (!props.transportBooking.originalChangesSeenAt) return true
  else if (
    dayjs(props.transportBooking.originalChangesSeenAt).isAfter(
      props.transportBooking.originalAttributesChangedAt,
    )
  )
    return false
  else return true
})
</script>

<template lang="pug">
template(v-if="unseenOriginalChanges")
  true-false-label(:item="true" revertColors)
</template>
